import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_ERRORS,
  UPDATE_PROFILE_SUCCESS,
  SET_USER_ACTIVE_DECK,
  SET_USER_ACTIVE_TEAM,
  SET_DARK_MODE
} from '../types';

const authReducer = (state, action) => {
  switch (action.type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: action.payload
      };
    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user,
        isAuthenticated: true,
        loading: false,
        error: null
      };
    case REGISTER_FAIL:
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem('token');
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        error: action.payload
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false
      };
    case SET_USER_ACTIVE_DECK:
      return {
        ...state,
        user: action.payload,
        loading: false
      };
    case SET_USER_ACTIVE_TEAM:
      return {
        ...state,
        user: action.payload,
        loading: false
      };
    case SET_DARK_MODE:
      return {
        ...state,
        user: action.payload,
        loading: false
      };
    default:
      return state;
  }
};

export default authReducer;
